/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactevidenceziptitle3Inputs */

const en_artifactevidenceziptitle3 = /** @type {(inputs: Artifactevidenceziptitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence ZIP`)
};

const pt_artifactevidenceziptitle3 = /** @type {(inputs: Artifactevidenceziptitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZIP de provas`)
};

/**
* | output |
* | --- |
* | "Evidence ZIP" |
*
* @param {Artifactevidenceziptitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactevidenceziptitle3 = /** @type {((inputs?: Artifactevidenceziptitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactevidenceziptitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactevidenceziptitle3(inputs)
	return pt_artifactevidenceziptitle3(inputs)
});
export { artifactevidenceziptitle3 as "artifactEvidenceZipTitle" }